import { render } from "./corpCoupon-detail.vue?vue&type=template&id=43fe5798&scoped=true"
import script from "./corpCoupon-detail.vue?vue&type=script&lang=js"
export * from "./corpCoupon-detail.vue?vue&type=script&lang=js"

import "./corpCoupon-detail.vue?vue&type=style&index=0&id=43fe5798&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\YCTECH\\ycform\\trunk\\ycform-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43fe5798"]])

export default __exports__